'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _lodash = require('lodash');

var _chemist = require('chemist');

var _FormInput = require('../FormInput');

var _address = require('../../helpers/address');

var _CountryTooltip = require('../CountryTooltip');

var _CountryTooltip2 = _interopRequireDefault(_CountryTooltip);

var _addressForm = require('../../actions/addressForm');

var _EnterAddressFormStyle = require('./EnterAddressFormStyle.scss');

var _EnterAddressFormStyle2 = _interopRequireDefault(_EnterAddressFormStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER_KEY_CODE = 13;

var AddressFormFieldsWithPostcodeLookup = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactRedux.connect)(function (state, props) {
  return {
    addressDetails: state.addressForm.addressDetails[props.prefix]
  };
}), _dec3 = (0, _reactI18next.translate)(), _dec4 = (0, _reactCssModules2.default)(_EnterAddressFormStyle2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AddressFormFieldsWithPostcodeLookup, _React$Component);

  function AddressFormFieldsWithPostcodeLookup(props, context) {
    (0, _classCallCheck3.default)(this, AddressFormFieldsWithPostcodeLookup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddressFormFieldsWithPostcodeLookup.__proto__ || (0, _getPrototypeOf2.default)(AddressFormFieldsWithPostcodeLookup)).call(this, props, context));

    var prefix = props.prefix,
        addressDetails = props.addressDetails;

    var address1 = addressDetails.address_line_1 || _this.addressAttribute('address1');
    var address2 = addressDetails.address_line_2 || _this.addressAttribute('address2');
    var houseNumber = addressDetails.house_number || _this.addressAttribute('house_number');
    var houseNumberAddition = addressDetails.house_number_addition || _this.addressAttribute('house_number_addition');
    var addressCity = addressDetails.city || _this.addressAttribute('city');
    _this.state = {
      address: props.order[prefix + 'Address'] || {},
      zipcode: _this.addressAttribute('zipcode'),
      selectedLookupAddress: '',
      addressDetails: {
        address_line_1: address1,
        address_line_2: address2,
        house_number: houseNumber,
        house_number_addition: houseNumberAddition,
        city: addressCity
      }
    };
    return _this;
  }

  (0, _createClass3.default)(AddressFormFieldsWithPostcodeLookup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.selectedAddressDetails !== undefined && !(0, _lodash.isEmpty)(this.props.selectedAddressDetails)) {
        this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'address1', this.props.selectedAddressDetails.address_line_1));

        this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'address2', this.props.selectedAddressDetails.address_line_2));

        this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'house_number', this.props.selectedAddressDetails.house_number));

        this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'house_number_addition', this.props.selectedAddressDetails.house_number_addition));

        this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'city', this.props.selectedAddressDetails.city));

        this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'state_name', this.props.selectedAddressDetails.stateName));

        this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'zipcode', this.props.selectedAddressDetails.postcode));
      }

      var address = this.props.order[this.props.prefix + 'Address'];

      if (address) {
        if (address.city && address.zipcode && address.address1) {
          this.props.dispatch((0, _addressForm.disablePostcodeLookup)(this.props.prefix));
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.addressDetails !== this.props.addressDetails) {
        this.setState({ addressDetails: nextProps.addressDetails });
      }
    }
  }, {
    key: 'getAddresses',
    value: function getAddresses(prefix, event) {
      event.preventDefault();

      var houseNumber = this.state.houseNumber;
      var zipCode = this.addressAttribute('zipcode');

      var zipcodeAndHouseNumber = houseNumber ? zipCode + ' ' + houseNumber : zipCode;

      var payload = {
        zipcode: zipcodeAndHouseNumber,
        country: this.props.country.iso,
        locale: this.props.order.language,
        prefix: prefix.toUpperCase()
      };

      return this.props.onGetAddresses(payload);
    }
  }, {
    key: 'getAddress',
    value: function getAddress(prefix, e) {
      e.preventDefault();

      var value = e.currentTarget.value;

      if (value === '') {
        this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'lookupAddressIsSelected', false));
        this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'lookupAddressRecord', value));
        return;
      }

      this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'lookupAddressIsSelected', true));
      this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, 'lookupAddressRecord', value));
      this.props.onGetAddress({ id: value, prefix: prefix.toUpperCase() });
    }
  }, {
    key: 'addressAttribute',
    value: function addressAttribute(name) {
      var _props = this.props,
          prefix = _props.prefix,
          order = _props.order,
          addressDetails = _props.addressDetails;


      return (0, _address.addressValueFor)(prefix, name, addressDetails, order);
    }
  }, {
    key: 'formErrors',
    value: function formErrors() {
      return this.props.errors || {};
    }
  }, {
    key: 'handleZipcodeChange',
    value: function handleZipcodeChange(e) {
      this.handleChange('zipcode', e);
      this.handleKeyUp('zipcode', e);
    }
  }, {
    key: 'handleKeyUpHouseNumber',
    value: function handleKeyUpHouseNumber(e) {
      this.setState({ houseNumber: e.currentTarget.value });
    }
  }, {
    key: 'submitPostcodeLookupForm',
    value: function submitPostcodeLookupForm(e) {
      if (this.props.addressDetails.postcodeLookupVisible && e.which === ENTER_KEY_CODE) {
        e.preventDefault();
        this.getAddresses(this.props.prefix, e);
      }
    }
  }, {
    key: 'updateField',
    value: function updateField(fieldName, value) {
      this.props.onFieldChange(fieldName, value);
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(fieldName, e) {
      this.updateField(fieldName, e.currentTarget.value);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(fieldName, e) {
      this.handleValueChange(fieldName, e.target.value);
    }
  }, {
    key: 'handleValueChange',
    value: function handleValueChange(fieldName, value) {
      this.props.dispatch((0, _addressForm.saveAddressDetails)(this.props.prefix, fieldName, value));
      this.updateField(fieldName, value);
    }
  }, {
    key: 'handleAddressPopulation',
    value: function handleAddressPopulation(e) {
      this.setState({ prefillAddress: e.currentTarget.value });
    }
  }, {
    key: 'enablePostcodeLookup',
    value: function enablePostcodeLookup(e) {
      e.preventDefault();

      this.props.dispatch((0, _addressForm.enablePostcodeLookup)(this.props.prefix));
      this.forceUpdate();
    }
  }, {
    key: 'disablePostcodeLookup',
    value: function disablePostcodeLookup(e) {
      e.preventDefault();

      this.props.dispatch((0, _addressForm.disablePostcodeLookup)(this.props.prefix));
      this.forceUpdate();
    }
  }, {
    key: 'addressOptionValues',
    value: function addressOptionValues() {
      var t = this.props.t;


      var lookupResultAddresses = (0, _lodash.map)(this.props.addresses, function (address) {
        return [address.id, address.label];
      });
      lookupResultAddresses.unshift(['', t('select_your_address')]);

      return lookupResultAddresses;
    }
  }, {
    key: 'stateOptionValues',
    value: function stateOptionValues() {
      var t = this.props.t;

      var states = (0, _lodash.map)(this.props.country.states, function (state) {
        return [state.name, state.name];
      });

      states.unshift(['', t('checkout_please_select')]);
      return states;
    }
  }, {
    key: 'stateInput',
    value: function stateInput() {
      if (this.props.country.states.length > 0) {
        return _react2.default.createElement(_FormInput.Select, {
          id: this.props.prefix + 'AddressStateName',
          name: 'order[' + this.props.prefix + '_address_attributes][state_name]',
          defaultValue: this.addressAttribute('state_name'),
          onChange: this.handleKeyUp.bind(this, 'stateName'),
          required: this.props.country.statesRequired,
          options: this.stateOptionValues()
        });
      }

      return _react2.default.createElement(_FormInput.Input, {
        id: this.props.prefix + 'AddressStateName',
        name: 'order[' + this.props.prefix + '_address_attributes][state_name]',
        defaultValue: this.addressAttribute('state_name'),
        onInput: this.handleKeyUp.bind(this, 'state_name'),
        onKeyUp: this.handleKeyUp.bind(this, 'state_name'),
        required: this.props.country.statesRequired
      });
    }
  }, {
    key: 'canPrefillAddress',
    value: function canPrefillAddress() {
      return !!this.addressAttribute('zipcode');
    }
  }, {
    key: 'renderZipcodeField',
    value: function renderZipcodeField() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$additionalStyles = _ref.additionalStyles,
          additionalStyles = _ref$additionalStyles === undefined ? '' : _ref$additionalStyles;

      var _props2 = this.props,
          t = _props2.t,
          prefix = _props2.prefix;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: additionalStyles,
            inputName: prefix + 'AddressZipcode',
            errors: this.formErrors(),
            inputLabel: t('spree.zipcode'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressZipcode',
            name: 'order[' + prefix + '_address_attributes][zipcode]',
            defaultValue: this.addressAttribute('zipcode'),
            onKeyPress: this.submitPostcodeLookupForm.bind(this),
            onChange: this.handleZipcodeChange.bind(this),
            required: true
          })
        ),
        _react2.default.createElement(
          'div',
          { styleName: additionalStyles + '__tooltip' },
          _react2.default.createElement(_CountryTooltip2.default, { country: this.props.country })
        )
      );
    }
  }, {
    key: 'renderPostcodeLookupForm',
    value: function renderPostcodeLookupForm() {
      var _props3 = this.props,
          t = _props3.t,
          prefix = _props3.prefix;

      var id = prefix + 'PostcodeLookupContainer';
      var visible = this.props.addressDetails.postcodeLookupVisible;
      var secondaryAddressStoreButtons = ['heritage'];

      var containerStyles = {};
      if (!visible) containerStyles.display = 'none';

      var zipcodeStyle = 'm-formField--lg-center-align-button';

      return _react2.default.createElement(
        'div',
        { id: id, styleName: 'm-formFieldPostcodeLookup', style: containerStyles },
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: 'm-formField--lg-left-align-button',
            inputName: prefix + 'AddressHouseNumber',
            errors: this.formErrors(),
            inputLabel: t('spree.house_number')
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressHouseNumber',
            name: 'order[' + prefix + '_address_attributes][house_number]',
            defaultValue: this.addressAttribute('houseNumber'),
            onKeyPress: this.submitPostcodeLookupForm.bind(this),
            onChange: this.handleChange.bind(this, 'houseNumber'),
            onKeyUp: this.handleKeyUpHouseNumber.bind(this),
            onInput: this.handleKeyUpHouseNumber.bind(this)
          })
        ),
        visible && this.renderZipcodeField({ additionalStyles: zipcodeStyle }),
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: 'm-formField--lg-right-align-button',
            inputName: prefix + 'Prefill'
          },
          _react2.default.createElement(
            _FormInput.Button,
            {
              weight: secondaryAddressStoreButtons.includes(this.props.config.theme) ? 'secondary' : 'primary',
              id: prefix + 'AddressZipcodeButton',
              onClick: this.getAddresses.bind(this, prefix),
              disabled: !this.canPrefillAddress()
            },
            t('spree.prefill_address')
          )
        )
      );
    }
  }, {
    key: 'renderSwitchToManualEntryButton',
    value: function renderSwitchToManualEntryButton() {
      if (!this.props.addressDetails.postcodeLookupVisible) return null;

      var _props4 = this.props,
          t = _props4.t,
          prefix = _props4.prefix;


      return _react2.default.createElement(
        _FormInput.Field,
        { inputName: prefix + 'ManualFill' },
        _react2.default.createElement(
          _FormInput.Button,
          {
            id: prefix + 'ManualFill',
            onClick: this.disablePostcodeLookup.bind(this),
            styleName: 'm-formField--lookup-manual-toggle-button',
            type: 'button'
          },
          t('spree.manually_enter_address'),
          ' \xBB'
        )
      );
    }
  }, {
    key: 'renderSwitchToPostcodeLookupButton',
    value: function renderSwitchToPostcodeLookupButton() {
      if (this.props.addressDetails.postcodeLookupVisible) return null;

      var t = this.props.t;


      return _react2.default.createElement(
        _FormInput.Field,
        { inputName: this.props.prefix + 'AddressFindAddressByPostcode' },
        _react2.default.createElement(
          _FormInput.Button,
          {
            id: this.props.prefix + 'AddressFindAddressByPostcode',
            onClick: this.enablePostcodeLookup.bind(this),
            styleName: 'm-formField--lookup-manual-toggle-button'
          },
          t('spree.lookup_address'),
          ' \xBB'
        )
      );
    }
  }, {
    key: 'renderSelectAddressField',
    value: function renderSelectAddressField() {
      var isAddressSelectVisible = this.props.addressDetails.postcodeLookupVisible && this.props.addresses;
      if (!isAddressSelectVisible) return null;

      return _react2.default.createElement(
        _FormInput.Field,
        {
          additionalStyles: 'm-formField',
          inputName: this.props.prefix + 'AddressPrefillSelect',
          errors: this.formErrors()
        },
        _react2.default.createElement(_FormInput.Select, {
          name: 'order[' + this.props.prefix + '_address_attributes][address_select]',
          onChange: this.getAddress.bind(this, this.props.prefix),
          options: this.addressOptionValues(),
          defaultValue: this.props.addressDetails.lookupAddressRecord,
          styleName: 'm-formField--postcode-address-select'
        })
      );
    }
  }, {
    key: 'renderStateField',
    value: function renderStateField() {
      if (!this.props.country.statesRequired) {
        return '';
      }

      var _props5 = this.props,
          t = _props5.t,
          prefix = _props5.prefix,
          country = _props5.country;


      return _react2.default.createElement(
        _FormInput.Field,
        {
          additionalStyles: 'm-formField--lg-right',
          inputName: prefix + 'AddressStateName',
          errors: this.formErrors(),
          inputLabel: t('spree.state'),
          fieldRequired: country.statesRequired
        },
        this.stateInput()
      );
    }
  }, {
    key: 'renderFreeAddressField',
    value: function renderFreeAddressField() {
      var _props6 = this.props,
          t = _props6.t,
          prefix = _props6.prefix;


      return _react2.default.createElement(
        _FormInput.Field,
        {
          inputName: prefix + 'AddressAddress1',
          errors: this.formErrors(),
          inputLabel: t('spree.street_address'),
          fieldRequired: true
        },
        _react2.default.createElement(_FormInput.Input, {
          id: prefix + 'AddressAddress1',
          name: 'order[' + prefix + '_address_attributes][address1]',
          defaultValue: this.addressAttribute('address1'),
          onChange: this.handleChange.bind(this, 'address1'),
          required: true
        })
      );
    }
  }, {
    key: 'renderStreetHouseNumberAddressFields',
    value: function renderStreetHouseNumberAddressFields() {
      var _props7 = this.props,
          t = _props7.t,
          prefix = _props7.prefix;


      var showHouseNumberAddition = this.props.config.store.addressWithHouseNumberAddition;

      return _react2.default.createElement(
        'div',
        {
          styleName: showHouseNumberAddition ? 'm-full-address-group' : 'm-full-address-group--no-addition'
        },
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: 'm-formField--full-address-address',
            inputName: prefix + 'AddressAddress1',
            errors: this.formErrors(),
            inputLabel: t('spree.street_address'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressAddress1',
            name: 'order[' + prefix + '_address_attributes][address1]',
            value: this.addressAttribute('address1'),
            onChange: this.handleChange.bind(this, 'address1'),
            required: true
          })
        ),
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: 'm-formField--full-address-house-number',
            inputName: prefix + 'AddressHouseNumber',
            errors: this.formErrors(),
            inputLabel: t('spree.house_number')
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressHouseNumber',
            name: 'order[' + prefix + '_address_attributes][house_number]',
            value: this.addressAttribute('houseNumber'),
            onChange: this.handleChange.bind(this, 'houseNumber')
          })
        ),
        showHouseNumberAddition && _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: 'm-formField--full-address-house-number-addition',
            inputName: prefix + 'AddressHouseNumberAddition',
            errors: this.formErrors(),
            inputLabel: t('spree.house_number_addition')
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressHouseNumberAddition',
            name: 'order[' + prefix + '_address_attributes][house_number_addition]',
            value: this.addressAttribute('houseNumberAddition'),
            onChange: this.handleChange.bind(this, 'houseNumberAddition')
          })
        )
      );
    }
  }, {
    key: 'renderAddressField',
    value: function renderAddressField() {
      if (this.props.config.store.addressWithHouseNumber) {
        return this.renderStreetHouseNumberAddressFields();
      }
      return this.renderFreeAddressField();
    }
  }, {
    key: 'renderAddressStreetFields',
    value: function renderAddressStreetFields() {
      var t = this.props.t;

      var visible = !this.props.addressDetails.postcodeLookupVisible;

      var containerStyles = {};
      if (!visible) containerStyles.display = 'none';

      return _react2.default.createElement(
        'div',
        { id: this.props.prefix + 'AddressFieldsContainer', style: containerStyles },
        this.renderAddressField(),
        _react2.default.createElement(
          _FormInput.Field,
          {
            inputName: this.props.prefix + 'AddressAddress2',
            errors: this.formErrors(),
            inputLabel: t('spree.street_address_2')
          },
          _react2.default.createElement(_FormInput.Input, {
            id: this.props.prefix + 'AddressAddress2',
            name: 'order[' + this.props.prefix + '_address_attributes][address2]',
            defaultValue: this.addressAttribute('address2'),
            onChange: this.handleChange.bind(this, 'address2')
          })
        ),
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: this.props.country.stateRequired ? 'm-formField--lg-left' : '',
            inputName: this.props.prefix + 'AddressCity',
            errors: this.formErrors(),
            inputLabel: t('spree.city'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: this.props.prefix + 'AddressCity',
            name: 'order[' + this.props.prefix + '_address_attributes][city]',
            defaultValue: this.addressAttribute('city'),
            onChange: this.handleChange.bind(this, 'city'),
            required: true
          })
        ),
        visible && this.renderZipcodeField()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props8 = this.props,
          t = _props8.t,
          prefix = _props8.prefix,
          config = _props8.config;
      var store = config.store;


      var companyStyleName = store.code === 'edeexp' ? 'm-formField--companyName-sikkens' : 'm-formField--companyName';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _FormInput.Field,
          {
            additionalStyles: companyStyleName,
            inputName: this.props.prefix + 'AddressCompanyname',
            errors: this.formErrors(),
            inputLabel: t('spree.company_name')
          },
          _react2.default.createElement(_FormInput.Input, {
            id: this.props.prefix + 'AddressCompanyname',
            name: 'order[' + this.props.prefix + '_address_attributes][company]',
            defaultValue: this.addressAttribute('companyname'),
            onKeyUp: this.handleKeyUp.bind(this, 'companyname'),
            onChange: this.handleChange.bind(this, 'companyname'),
            onInput: this.handleKeyUp.bind(this, 'companyname')
          })
        ),
        _react2.default.createElement(
          _FormInput.Field,
          {
            inputName: prefix + 'AddressFirstname',
            errors: this.formErrors(),
            inputLabel: t('spree.first_name'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressFirstname',
            name: 'order[' + prefix + '_address_attributes][firstname]',
            defaultValue: this.addressAttribute('firstname'),
            onKeyUp: this.handleKeyUp.bind(this, 'firstname'),
            onInput: this.handleKeyUp.bind(this, 'firstname'),
            onChange: this.handleChange.bind(this, 'firstname'),
            required: true
          })
        ),
        _react2.default.createElement(
          _FormInput.Field,
          {
            inputName: prefix + 'AddressLastname',
            errors: this.formErrors(),
            inputLabel: t('spree.last_name'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressLastname',
            name: 'order[' + prefix + '_address_attributes][lastname]',
            defaultValue: this.addressAttribute('lastname'),
            onKeyUp: this.handleKeyUp.bind(this, 'lastname'),
            onInput: this.handleKeyUp.bind(this, 'lastname'),
            onChange: this.handleChange.bind(this, 'lastname'),
            required: true
          })
        ),
        _react2.default.createElement(
          _FormInput.Field,
          {
            inputName: prefix + 'AddressPhone',
            errors: this.formErrors(),
            inputLabel: t('spree.phone'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: prefix + 'AddressPhone',
            name: 'order[' + prefix + '_address_attributes][phone]',
            defaultValue: this.addressAttribute('phone'),
            onKeyUp: this.handleKeyUp.bind(this, 'phone'),
            onInput: this.handleKeyUp.bind(this, 'phone'),
            onChange: this.handleChange.bind(this, 'phone'),
            required: true,
            type: 'tel',
            pattern: '^[\\d\\s]+$'
          })
        ),
        this.renderAddressStreetFields(),
        this.renderStateField(),
        this.renderPostcodeLookupForm(),
        this.renderSelectAddressField(),
        this.renderSwitchToManualEntryButton(),
        this.renderSwitchToPostcodeLookupButton()
      );
    }
  }]);
  return AddressFormFieldsWithPostcodeLookup;
}(_react2.default.Component), _class2.propTypes = {
  order: _react.PropTypes.object.isRequired,
  country: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object,
  prefix: _react.PropTypes.string.isRequired,
  onFieldChange: _react.PropTypes.func,
  onGetAddresses: _react.PropTypes.func,
  onGetAddress: _react.PropTypes.func,
  shipAddresses: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    id: _react.PropTypes.string,
    label: _react.PropTypes.string
  })),
  shipAddressDetail: _react.PropTypes.shape({
    address_1: _react.PropTypes.string,
    address_2: _react.PropTypes.string,
    city: _react.PropTypes.string
  }),
  billAddresses: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    id: _react.PropTypes.string,
    label: _react.PropTypes.string
  })),
  billAddressDetail: _react.PropTypes.shape({
    address_1: _react.PropTypes.string,
    address_2: _react.PropTypes.string,
    city: _react.PropTypes.string
  })
}, _class2.defaultProps = {
  onFieldChange: function onFieldChange() {},
  onGetAddresses: function onGetAddresses() {},
  onGetAddress: function onGetAddress() {},
  selectedAddressDetails: {}
}, _temp)) || _class) || _class) || _class) || _class);
exports.default = AddressFormFieldsWithPostcodeLookup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressForm/AddressFormFieldsWithPostcodeLookup.js
// module id = 2440
// module chunks = 0